import { render } from "./DependentsTable.vue?vue&type=template&id=32599e6f&ts=true"
import script from "./DependentsTable.vue?vue&type=script&lang=ts"
export * from "./DependentsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__